import React from 'react';
import cc from 'classcat';
import InfoField from '../InfoField';

export interface Item {
    title: string;
    subtitle?: string | string[];
    hidable?: boolean;
    isOneLine?: boolean;
    moreThanOne?: boolean;
}

interface InformationSectionProps {
    title?: string;
    icon?: string;
    items: Item[];
    onIconClick?: () => void;
    paddingY?: boolean;
}

const InformationSection: React.FC<InformationSectionProps> = ({ title, icon, items, onIconClick, paddingY = true }) => {
    return (
        <div className={cc([{ 'information-section': paddingY }, { 'information-section--small-padding': !title }])}>
            <div className="information-section__title">
                <h3 className="information-section__title-text">{title}</h3>
                {icon && <img onClick={onIconClick} src={icon} alt="Icon" />}
            </div>
            <div className="information-section__columns">
                {items.map(item => (
                    <InfoField
                        key={item.title}
                        label={item.title}
                        value={item.subtitle || '-'}
                        moreThanOneItem={item.moreThanOne}
                        hidable={item.hidable}
                        isOneLine={item.isOneLine}
                    />
                ))}
            </div>
        </div>
    );
};

export default InformationSection;
